// default belongs to either the wordset or the sentenceset

import { IconName } from '@/components/Icon';

type Task = {
  default: {
    label: string;
    iconName: IconName;
    iconLibrary: string;
    exerciseSettingsKey: 'Sprechen' | 'Lesen' | 'Schreiben' | 'Verstehen';
  }[];
  textset: {
    label: string;
    iconName: IconName;
    iconLibrary: string;
    exerciseSettingsKey: 'Sprechen' | 'Lesen' | 'Schreiben' | 'Verstehen';
  }[];
};

export const TASKS: Task = {
  default: [
    {
      label: 'Auditives Sprachverständnis',
      iconName: 'ear-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Verstehen',
    },
    {
      label: 'Mündliches Benennen',
      iconName: 'bubble',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Sprechen',
    },
    {
      label: 'Lesesinnverständnis',
      iconName: 'book-open',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Lesen',
    },
    {
      label: 'Schriftliches Benennen',
      iconName: 'pencil-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Schreiben',
    },
  ],
  textset: [
    {
      label: 'Auditives Sprachverständnis',
      iconName: 'ear-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Verstehen',
    },
    {
      label: 'Mündliches Nacherzählen',
      iconName: 'bubble',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Sprechen',
    },
    {
      label: 'Lesesinnverständnis',
      iconName: 'book-open',
      iconLibrary: 'SimpleLineIcons',
      exerciseSettingsKey: 'Lesen',
    },
    {
      label: 'Schreiben',
      iconName: 'pencil-outline',
      iconLibrary: 'Ionicons',
      exerciseSettingsKey: 'Schreiben',
    },
  ],
};
